import {useMutation} from '@tanstack/react-query';
import {queryClient} from '@/utils/reactQueryClient';
import contentSubmissionUpdaters, {
  ReviseSubmissionPayload,
} from '@/api/updaters/contentSubmissions';
import {gigSubmissionsQueryKey} from '@/hooks/queries/content-submissions/use-gig-submissions-query';
import {paidGigDetailQueryKey} from '@/hooks/queries/gigs/use-paid-gig-detail-query';

export default function useReviseSubmission(
  gigId: string,
  {onError}: {onError?: (e: unknown) => void} = {}
) {
  return useMutation({
    mutationKey: ['reviseSubmission', gigId],
    mutationFn: ({
      submissionId,
      payload,
    }: {
      submissionId: string;
      payload: ReviseSubmissionPayload;
    }) => contentSubmissionUpdaters.revise(gigId, submissionId, payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: gigSubmissionsQueryKey(gigId),
      });
      await queryClient.invalidateQueries({
        queryKey: paidGigDetailQueryKey(gigId),
      });
    },
    onError,
  });
}
